import { HStack, Input, InputGroup, Spinner } from "@chakra-ui/react"
import Pathicon from "../../pathicon/Pathicon"
import { usePathNavigator } from "./PathNavigatorContext"
import PathNavigatorFilterMenu from "./PathNavigatorFilterMenu"

type PathNavigatorSearchProps = {
  onFocus?: () => void
}

const PathNavigatorSearch = ({ onFocus }: PathNavigatorSearchProps) => {
  const {
    search,
    setSearch,
    searchIsLoading,
    searchInputRef,
    inlineMode,
    displayFilterMenu
  } = usePathNavigator()

  return (
    <HStack pt={inlineMode ? 2 : 7} className="path-navigator-search" w="100%">
      <InputGroup
        position="relative"
        borderRadius="40px"
        overflow="hidden"
        startElement={<Pathicon icon="search" color="whiteAlpha.500" />}
        endElement={
          searchIsLoading ? <Spinner size="sm" color="white" /> : null
        }
      >
        <Input
          type="search"
          ref={searchInputRef}
          defaultValue={search}
          pt={"1px"}
          pl={10}
          border="none"
          bg="whiteAlpha.300"
          _focus={{
            bg: "whiteAlpha.400"
          }}
          _placeholder={{
            color: "whiteAlpha.700"
          }}
          color="white"
          onFocus={onFocus}
          aria-label="Search Path"
          aria-describedby="navigator-search-results-status"
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search Path..."
          css={{
            "&::-webkit-search-cancel-button": {
              WebkitAppearance: "none",
              display: "none"
            }
          }}
        />
      </InputGroup>
      {displayFilterMenu ? <PathNavigatorFilterMenu /> : null}
    </HStack>
  )
}

export default PathNavigatorSearch
